import { type FC } from 'react';
import classnames from 'classnames';
import { ItemTilesCarouselShimmer } from 'dibs-product-tile-carousel/exports/ItemTilesCarouselShimmer.ts';
import { ChipPlaceholder } from 'dibs-elements/exports/Chip.ts';

import dibsCss from 'dibs-css';

const CAROUSEL_ITEMS_TO_SHOW_RESP = 5;
const CAROUSEL_ITEMS_TO_SHOW_MOBILE = 1.5;

type ChipProps = {
    isMobile: boolean;
};

type Props = ChipProps & {
    itemsToShow?: number;
};

const ChipShimmerRow: FC<ChipProps> = ({ isMobile }) => (
    <div
        className={classnames(
            dibsCss.flex,
            dibsCss.gapXsmall,
            dibsCss.wFull,
            isMobile ? dibsCss.justifyStart : dibsCss.justifyCenter
        )}
    >
        {[0, 1, 2].map(index => (
            <ChipPlaceholder key={index} className={dibsCss.loadingShimmer} />
        ))}
    </div>
);

export const HpSharedCarouselTabsShimmer: FC<Props> = ({
    isMobile,
    itemsToShow: itemsToShowProp,
}) => {
    const itemsToShow =
        itemsToShowProp ?? (isMobile ? CAROUSEL_ITEMS_TO_SHOW_MOBILE : CAROUSEL_ITEMS_TO_SHOW_RESP);

    return (
        <div
            className={classnames(
                dibsCss.wFull,
                dibsCss.flex,
                dibsCss.flexCol,
                dibsCss.gapMedium,
                dibsCss.mtLarger
            )}
        >
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexCol,
                    isMobile
                        ? [dibsCss.itemsStart, dibsCss.gapSmall]
                        : [dibsCss.itemsCenter, dibsCss.gapMedium]
                )}
            >
                <div
                    className={classnames(
                        dibsCss.loadingShimmer,
                        dibsCss.bgMoonstone,
                        dibsCss.hLarge,
                        dibsCss.w300px,
                        dibsCss.roundedFull,
                        isMobile ? dibsCss.textLeft : dibsCss.textCenter
                    )}
                />

                <ChipShimmerRow isMobile={isMobile} />
            </div>

            <div className={classnames(dibsCss.flex, dibsCss.flexCol)}>
                <ItemTilesCarouselShimmer
                    fullWidth={!!isMobile}
                    gapSize="small"
                    itemsToShow={itemsToShow}
                    showArrows={!isMobile}
                    size="medium"
                />
                <div className={classnames(isMobile ? dibsCss.selfStart : dibsCss.selfEnd)}>
                    <div
                        className={classnames(
                            dibsCss.loadingShimmer,
                            dibsCss.bgMoonstone,
                            dibsCss.hSmall,
                            dibsCss.w100px,
                            dibsCss.rounded2px
                        )}
                    />
                </div>
            </div>
        </div>
    );
};
